import React from "react";
import { useState, useEffect } from "react"
import { Modal, Button } from "react-bootstrap";
import { productivityServices } from "./Productivity.services";
import { commonServices } from "../../../commonServices/commonServices";

export default function PSLeaderboard() {

    const [showPsFormulaModal, setShowPsFormulaModal] = useState(false);
    const [options, setOptions] = useState([]);
    const [selectedCities, setSelectedCities] = useState([]);
    const [selectedMonth, setSelectedMonth] = useState("");
    const [selectedCity, setSelectedCity] = useState("");
    const [leaderboard, setLeaderboard] = useState([]);


    const generateMonthYearOptions = () => {
        const newOptions = [];
        const today = new Date();

        for (let i = 0; i < 12; i++) {
            const d = new Date(today.getFullYear(), today.getMonth() - i, 1)

            const month = d.getMonth() + 1;
            const year = d.getFullYear();

            const label = d.toLocaleString("default", {
                month: "long",
                year: "numeric"
            });

            newOptions.push({
                month,
                year,
                label
            });

        }
        setOptions(newOptions)
        setSelectedMonth({
            month: today.getMonth() + 1,
            year: today.getFullYear()
        });
    }

    const getCities = async () => {
        const data = { pmsOperationStatus: 'YES' };

        const result = await commonServices.getCities(data);

        if (result && result.status == 200) {
            const cities = result?.data?.cities || [];
            const formattedCities = commonServices.formatCities(cities);
            setSelectedCities(formattedCities);
        }
    }


    const getLeaderboard = async (month, year, cityId = "") => {

        const data = {
            month,
            year,
            cityId: cityId || null
        };

        const result = await productivityServices.getSupervisorLeaderBoard(data);

        if (result && result.status === 200) {
            setLeaderboard(result.data);
        }
    };


    useEffect(() => {
        generateMonthYearOptions();
        getCities();
    }, []);

    useEffect(() => {

        if (!selectedMonth) return;

        getLeaderboard(
            selectedMonth.month,
            selectedMonth.year,
            selectedCity
        );

    }, [selectedMonth, selectedCity]);


    const totalMoveInAssigned = leaderboard.reduce(
        (total, item) => total + Number(item.moveInReportAssigned || 0), 0);
    const totalMoveInPublished = leaderboard.reduce(
        (total, item) => total + Number(item.moveInReportPublished || 0), 0);
    const totalMoveInPercentage = Math.round((totalMoveInPublished / totalMoveInAssigned) * 100);


    const totalMoveOutAssigned = leaderboard.reduce(
        (total, item) => total + Number(item.moveOutReportAssigned || 0), 0);
    const totalMoveOutPublished = leaderboard.reduce(
        (total, item) => total + Number(item.moveOutReportPublished || 0), 0);
    const totalMoveOutPercentage = Math.round((totalMoveOutPublished / totalMoveOutAssigned) * 100);


    const totalInspectionAssigned = leaderboard.reduce(
        (total, item) => total + Number(item.inspectionReportAssigned || 0), 0);
    const totalInspectionPublished = leaderboard.reduce(
        (total, item) => total + Number(item.inspectionReportPublished || 0), 0);
    const totalInspectionPercentage = Math.round((totalInspectionPublished / totalInspectionAssigned) * 100);


    const totalServiceRequestAssigned = leaderboard.reduce(
        (total, item) => total + Number(item.serviceRequestAssigned || 0), 0);
    const totalServiceRequestPublished = leaderboard.reduce(
        (total, item) => total + Number(item.serviceRequestCompleted || 0), 0);
    const totalServiceRequestPercentage = Math.round((totalServiceRequestPublished / totalServiceRequestAssigned) * 100);

    const qualifiers = leaderboard.filter(item => Number(item.productivity) >= 100).length;

    const totalIncentive = leaderboard.reduce((total, item) => {
        const points = Number(item.productivity);

        if (points >= 150) {
            return total + 4100;
        }

        if (points > 125) {
            return total + 3100;
        }

        if (points >= 100) {
            return total + 2100;
        }

        return total;
    }, 0);


    return (

        <>

            <div className="container-fluid py-4 bg-light">
                <br></br>
                <div className="d-flex align-items-center mb-4">
                    <h2 className="font-weight-bold mb-0 text-dark">
                        PS Scoreboard & Leaderboard
                    </h2>

                    <span className="badge badge-primary ml-3 px-3 py-2">
                        {leaderboard.length} PS
                    </span>

                    <button className="btn btn-outline-danger btn-sm ml-3" onClick={() => setShowPsFormulaModal(true)}>
                        ℹ️Points Formula
                    </button>

                    <div className="ml-3">
                        <select className="form-control form-control-md"
                            value={selectedMonth ? `${selectedMonth.month}-${selectedMonth.year}` : ""}
                            onChange={(e) => {
                                const [month, year] = e.target.value.split("-");
                                setSelectedMonth({
                                    month: Number(month),
                                    year: Number(year)
                                });
                            }}
                        >

                            {options.map((option) => (
                                <option
                                    key={`${option.month}-${option.year}`}
                                    value={`${option.month}-${option.year}`}
                                >{option.label}</option>
                            ))}
                        </select>
                    </div>


                    <br></br>


                    <div className="ml-3">

                        <select
                            className="form-control form-control-md"
                            value={selectedCity}
                            onChange={(e) =>
                                setSelectedCity(e.target.value)
                            }
                        >

                            <option value="">
                                All Cities
                            </option>

                            {selectedCities.map((city) => (

                                <option
                                    key={city.id}
                                    value={city.id}
                                >
                                    {city.name}
                                </option>

                            ))}

                        </select>
                    </div>
                </div>

                <br></br>

                <div className="card">
                    <div className="card-body py-1 px-3">
                        <div className="d-flex align-items-center flex-wrap">
                            <strong className="mr-3 mb-2">🎁 Incentive based on Productivity %:</strong>

                            <div className="badge badge-warning font-weight-bold mb-0 text-dark p-3 mr-2 mb-2">
                                🏆 150+ : ₹4,100
                            </div>

                            <div className="badge badge-secondary font-weight-bold mb-0 text-dark p-3 mr-2 mb-2">
                                🎯 126-150 : ₹3,100
                            </div>

                            <div className="badge badge-info font-weight-bold mb-0 text-dark p-3 mb-2">
                                ⭐ 100-125 : ₹2,100
                            </div>
                        </div>
                    </div>
                </div>

                {leaderboard && leaderboard.length > 0 ? (
                    <>
                        <br></br>

                        <div className="row mb-4">
                            <div className="col-md-2 mb-3">
                                <div className="card">
                                    <div className="card-body py-2 px-3 text-center">
                                        <h6 className="mb-1 small text-dark">🚚 Move-In Reports</h6>
                                        <h5 className="font-weight-bold mb-1 text-dark">{totalMoveInPublished} / {totalMoveInAssigned}</h5>
                                        <span className="badge badge-success">{totalMoveInPercentage ? totalMoveInPercentage : 0}%</span>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-2 mb-3">
                                <div className="card">
                                    <div className="card-body py-2 px-3 text-center">
                                        <h6 className="mb-1 small text-dark">📦 Move-Out Reports</h6>
                                        <h5 className="font-weight-bold mb-1 text-dark">{totalMoveOutPublished} / {totalMoveOutAssigned}</h5>
                                        <span className="badge badge-success">{totalMoveOutPercentage ? totalMoveOutPercentage : 0}%</span>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-2 mb-3">
                                <div className="card">
                                    <div className="card-body py-2 px-3 text-center">
                                        <h6 className="mb-1 small text-dark">🔍 Periodic Inspections</h6>
                                        <h5 className="font-weight-bold mb-1 text-dark">{totalInspectionPublished} / {totalInspectionAssigned}</h5>
                                        <span className="badge badge-success">{totalInspectionPercentage ? totalInspectionPercentage : 0}%</span>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-2 mb-3">
                                <div className="card">
                                    <div className="card-body py-2 px-3 text-center">
                                        <h6 className="mb-1 small text-dark">🛠 Service Requests</h6>
                                        <h5 className="font-weight-bold mb-1 text-dark">{totalServiceRequestPublished} / {totalServiceRequestAssigned}</h5>
                                        <span className="badge badge-success">{totalServiceRequestPercentage ? totalServiceRequestPercentage : 0}%</span>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-2 mb-3">
                                <div className="card border-success">
                                    <div className="card-body py-2 px-3 text-center">
                                        <h6 className="mb-1 small text-dark">💸 Incentives Earned</h6>
                                        <h5 className="text-success font-weight-bold mb-1">
                                            ₹{totalIncentive}
                                        </h5>
                                        <small>{qualifiers} Qualifiers ({Math.round((qualifiers / leaderboard.length) * 100)}%)</small>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-2 mb-3">
                                <div className="card border-warning">
                                    <div className="card-body py-2 px-3 text-center">
                                        <h6 className="mb-1 small text-dark">👑 Top Scorer</h6>
                                        <h5 className="font-weight-bold text-warning mb-1">
                                            {leaderboard[0]?.user}
                                        </h5>
                                        <small>{leaderboard[0]?.productivity} • {leaderboard[0]?.productivity >= 150 ? "₹4,100" : leaderboard[0]?.productivity > 125 && leaderboard[0]?.productivity < 150 ? "₹3,100" : leaderboard[0]?.productivity > 100 && leaderboard[0]?.productivity <= 125 ? "₹2,100" : "0"}</small>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="card">
                            <div className="card-body p-0">
                                <div className="table-responsive">
                                    <table className="table table-hover mb-0">
                                        <thead className="thead-light">
                                            <tr>
                                                <th>Rank</th>
                                                <th>Name</th>
                                                <th>Productivity</th>
                                                <th>Move-In Reports</th>
                                                <th>Move-Out Reports</th>
                                                <th>Periodic Inspections</th>
                                                <th>Service Requests</th>
                                            </tr>
                                        </thead>
                                        {leaderboard.map((item, index) => (
                                            <tbody>
                                                <tr className={index === 0 ? "table-warning" : index === 1 ? "table-secondary" : index === 2 ? "table-danger" : ""}>
                                                    <td>
                                                        <span className={index === 0 ? "badge badge-warning p-2" : index === 1 ? "badge badge-secondary p-2" : index === 2 ? "badge badge-danger p-2" : "badge badge-light p-2"}>
                                                            {index + 1}
                                                        </span>
                                                    </td>

                                                    <td>
                                                        <strong>{item.user}</strong>
                                                        <br />
                                                        <small>{item.city} {index + 1 === 1 ? ' - 1st Rank Champion' : index + 1 === 2 ? ' - 2nd Rank Champion' : index + 1 === 3 ? ' - 3rd Rank Champion' : ''}</small>
                                                    </td>

                                                    <td>
                                                        <strong>{Math.round(item.productivity)}</strong> %
                                                        <br />
                                                        <span className="badge badge-warning">
                                                            {item.productivity >= 150 ? "₹4,100" : item.productivity > 125 && item.productivity < 150 ? "₹3,100" : item.productivity > 100 && item.productivity <= 125 ? "₹2,100" : "0"}
                                                        </span>
                                                    </td>

                                                    <td>
                                                        {Math.trunc(item.moveInReportPublished)} / {Math.trunc(item.moveInReportAssigned)}
                                                        <span className="badge badge-success ml-2">
                                                            {Math.trunc(item.moveInReportPercentage)}%
                                                        </span>
                                                    </td>

                                                    <td>
                                                        {Math.trunc(item.moveOutReportPublished)} / {Math.trunc(item.moveOutReportAssigned)}
                                                        <span className="badge badge-success ml-2">
                                                            {Math.trunc(item.moveOutReportPercentage)}%
                                                        </span>
                                                    </td>

                                                    <td>
                                                        {Math.trunc(item.inspectionReportPublished)} / {Math.trunc(item.inspectionReportAssigned)}
                                                        <span className="badge badge-success ml-2">
                                                            {Math.trunc(item.inspectionReportPercentage)}%
                                                        </span>
                                                    </td>

                                                    <td>
                                                        {Math.trunc(item.serviceRequestCompleted)} / {Math.trunc(item.serviceRequestAssigned)}
                                                        <span className="badge badge-success ml-2">
                                                            {Math.trunc(item.serviceRequestCompletionPercentage)}%
                                                        </span>
                                                    </td>
                                                </tr>

                                            </tbody>
                                        ))}

                                    </table>
                                </div>
                            </div>
                        </div>

                    </>) : (<p>No supervisor found</p>)}

            </div>

            <Modal
                show={showPsFormulaModal}
                onHide={() => setShowPsFormulaModal(false)}
                backdrop="static"
                centered
                size="lg"
                scrollable
            >
                <Modal.Header closeButton className="bg-light py-2 px-3">
                    <Modal.Title>
                        <div className="d-flex align-items-center">

                            <div className="mr-2">
                                <span className="h5 mb-0">ℹ️</span>
                            </div>

                            <div>
                                <h5 className="mb-0 font-weight-bold text-dark">
                                    PS Points Calculation Formula
                                </h5>

                                <small className="text-muted">
                                    PS performance metrics, KPI targets & incentive criteria
                                </small>
                            </div>

                        </div>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className="px-3 py-3">

                    {/* PS Performance Metrics */}
                    <h6 className="font-weight-bold text-dark mb-2">
                        🧮 PS PERFORMANCE METRICS
                    </h6>

                    <p className="text-muted small mb-2">
                        Points are awarded based on completed Service Requests and
                        Report Jobs.
                    </p>

                    <div className="table-responsive mb-3">
                        <table className="table table-bordered table-sm mb-0">
                            <thead className="thead-light">
                                <tr>
                                    <th className="py-2">Category</th>
                                    <th className="py-2">Metric</th>
                                    <th className="text-right py-2">Points</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr>
                                    <td rowSpan="3" className="font-weight-bold align-middle">
                                        Service Requests (SRs)
                                    </td>

                                    <td>
                                        Every unique property SR closed
                                    </td>

                                    <td className="text-right font-weight-bold text-primary">
                                        2 Points
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        Additional SR closed on the same property
                                    </td>

                                    <td className="text-right font-weight-bold text-primary">
                                        1 Point
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        Maximum points per property per day
                                    </td>

                                    <td className="text-right font-weight-bold text-primary">
                                        4 Points
                                    </td>
                                </tr>

                                <tr>
                                    <td className="font-weight-bold align-middle">
                                        Report Jobs
                                    </td>

                                    <td>
                                        Move-in / Move-out / Periodic Inspection
                                    </td>

                                    <td className="text-right font-weight-bold text-primary">
                                        2.5 Points per report
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <h6 className="font-weight-bold text-dark mb-2">
                        🎁 INCENTIVE STRUCTURE BASED ON PRODUCTIVITY PERCENTAGE
                    </h6>

                    <div className="alert alert-warning py-2 px-3 mb-2">
                        <div className="row align-items-center">
                            <div className="col-sm-4 font-weight-bold text-nowrap">
                                🏆 Top Tier
                            </div>

                            <div className="col-sm-4 text-center font-weight-bold">
                                150+ 
                            </div>

                            <div className="col-sm-4 text-right font-weight-bold">
                                ₹4,100
                            </div>
                        </div>
                    </div>


                    <div className="alert alert-info py-2 px-3 mb-2">
                        <div className="row align-items-center">
                            <div className="col-sm-4 font-weight-bold text-nowrap">
                                ⭐ High Tier
                            </div>

                            <div className="col-sm-4 text-center font-weight-bold">
                                125 – 150 
                            </div>

                            <div className="col-sm-4 text-right font-weight-bold">
                                ₹3,100
                            </div>
                        </div>
                    </div>



                    <div className="alert alert-primary py-2 px-3 mb-2">
                        <div className="row align-items-center">
                            <div className="col-sm-4 font-weight-bold text-nowrap">
                                🎯 Starter Tier
                            </div>

                            <div className="col-sm-4 text-center font-weight-bold">
                                100 – 125 
                            </div>

                            <div className="col-sm-4 text-right font-weight-bold">
                                ₹2,100
                            </div>
                        </div>
                    </div>


                    <div className="card bg-light border-0">
                        <div className="card-body py-2 px-3">

                            <h6 className="font-weight-bold text-dark mb-2">
                                📌 Important Notes
                            </h6>

                            <ul className="mb-0 pl-3 small text-muted">

                                <li className="mb-1">
                                    2 points are awarded for every SR closed on a
                                    unique property.
                                </li>

                                <li className="mb-1">
                                    If another SR is closed on the same property,
                                    an additional 1 point is awarded.
                                </li>

                                <li className="mb-1">
                                    A maximum of 4 points can be earned per property
                                    per day, even if 3 or more SRs are closed.
                                </li>

                                <li>
                                    Each completed Move-in, Move-out, or Periodic
                                    Inspection Report earns 2.5 points.
                                </li>

                            </ul>

                        </div>
                    </div>

                </Modal.Body>

                <Modal.Footer className="bg-light py-2 px-3">

                    <Button variant="primary" size="sm" className="font-weight-bold px-3" onClick={() => setShowPsFormulaModal(false)}>
                        Got it!
                    </Button>

                </Modal.Footer>

            </Modal>
        </>

    );
}